<script setup lang="ts">
import AppMark from '../components/AppMark.vue'
</script>

<template>
  <main class="not-found">
    <a href="/" class="brand">
      <AppMark />
      <span>GetSlides</span>
    </a>
    <div>
      <span>404</span>
      <h1>Здесь нет слайда</h1>
      <p>Похоже, ссылка устарела или в адресе опечатка.</p>
      <a href="/" class="button button--primary">На главную</a>
    </div>
  </main>
</template>
